import { configureStore } from "@reduxjs/toolkit";
import sidebarReducer from "./features/sidebar";
import authReducer from "./features/auth";
import financeReducer from "./features/finance";
import profileReducer from "./features/profile";
import childrenReducer from "./features/children";
import eventsReducer from "./features/events";
import settingReducer from "./features/setting";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    sidebar: sidebarReducer,
    finance: financeReducer,
    profile: profileReducer,
    children: childrenReducer,
    events: eventsReducer,
    setting: settingReducer,
  },
  devTools: true,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
